import { Graphics } from 'pixi.js';
import { type System, ComponentStore } from '@ecs/world';
import { DEFAULT_TUNING, type Tuning } from '@game/tuning';
import type { AmmoComponent, CameraResource, TimeScaleResource, TransformComponent } from '@game/scenes/characterPrototype/types';
import { updateAmmoBarGraphic } from './ammoBarRender';

export type AmmoBarStyle = {
	playerFill: number;
	playerStroke: number;
	enemyFill: number;
	enemyStroke: number;
};

export type AmmoGraphicsSyncOptions = {
	style: AmmoBarStyle;
	yOffsetExtra: number;
};

export function createAmmoGraphicsSyncSystem(
	ammos: ComponentStore<AmmoComponent>,
	ammoGraphics: ComponentStore<Graphics>,
	transforms: ComponentStore<TransformComponent>,
	options: AmmoGraphicsSyncOptions
): System {
	return ({ world }) => {
		const tuning = world.getResource<Tuning>('tuning') ?? DEFAULT_TUNING;
		const timescale = world.getResource<TimeScaleResource>('timescale');
		const camera = world.getResource<CameraResource>('camera');
		const playerId = world.getResource<number>('player-entity');
		const offsetY = camera ? camera.y : 0;
		const alpha = timescale ? 0.85 + 0.15 * timescale.value : 1;

		ammoGraphics.forEach((g, entity) => {
			const t = transforms.get(entity);
			const ammo = ammos.get(entity);
			if (!t || !ammo) return;

			const isPlayer = playerId != null && entity === playerId;
			const size = isPlayer ? tuning.playerSize : tuning.enemySize;
			const yOffset = size * 0.5 + options.yOffsetExtra;
			g.position.set(t.x, t.y - offsetY - yOffset);
			g.alpha = alpha;

			updateAmmoBarGraphic(
				g,
				ammo,
				isPlayer ? options.style.playerFill : options.style.enemyFill,
				isPlayer ? options.style.playerStroke : options.style.enemyStroke,
				size
			);
		});
	};
}


